<template>
    <div class="titan-grid">
        <desktop :settings="settings"
                 :loading="loading"
                 :sortable="sortable"
                 :conditions="conditions"
                 :items="items"
                 @onFilter="setConditions($event)"
                 @buttonEvent="$emit('button-' + $event.event, $event.item)"
                 v-if="mobile === false"
        >
            <template :slot="column.key" slot-scope="slotData" v-for="column in columns">
                <slot :name="column.key" :item="slotData.item">
                    <column :item="slotData.item"
                            :settings="column"
                            :selected="selectedItems"
                            @toggleSelected="toggleSelected($event)"
                    />
                </slot>
            </template>
            <template slot="before-actions" slot-scope="slotData">
                <slot name="before-actions" :item="slotData.item"></slot>
            </template>
            <template slot="after-actions" slot-scope="slotData">
                <slot name="after-actions" :item="slotData.item"></slot>
            </template>
        </desktop>

        <mobile :settings="settings"
                :loading="loading"
                :sortable="sortable"
                :conditions="conditions"
                :items="items"
                @onFilter="setConditions($event)"
                @buttonEvent="$emit('button-' + $event.event, $event.item)"
                v-if="mobile === true"
        >
            <template :slot="column.key" slot-scope="slotData" v-for="column in columns">
                <slot :name="column.key" :item="slotData.item">
                    <column :item="slotData.item"
                            :settings="column"
                            :selected="selectedItems"
                            @toggleSelected="toggleSelected($event)"
                    />
                </slot>
            </template>
            <template slot="before-actions" slot-scope="slotData">
                <slot name="before-actions" :item="slotData.item"></slot>
            </template>
            <template slot="after-actions" slot-scope="slotData">
                <slot name="after-actions" :item="slotData.item"></slot>
            </template>
        </mobile>
        <div class="titan-grid-footer">
            <slot name="before-paginator" :item="paginator"></slot>
            <paginator v-if="loading === false && hidePaginator === false"
                       :pages="this.paginator.pages"
                       :page="this.page"
                       v-on:changePage="changePage($event)"
            />
            <slot name="after-paginator" :item="paginator"></slot>
        </div>
    </div>
</template>
<script>
    import Column from './Column'
    import Paginator from './Paginator'
    import AcceptAction from './../AcceptAction'
    import Buttons from "../Buttons";
    import GridFilter from "./GridFilter";
    import Desktop from "./tables/Desktop";
    import Mobile from "./tables/Mobile";
    import {getSortObject, getConditionsObject} from "./utils";

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faSort, faSortUp, faSortDown} from '@fortawesome/free-solid-svg-icons'

    library.add(faSort, faSortUp, faSortDown);

    export default {
        components: {
            GridFilter,
            Buttons,
            Column,
            Paginator,
            AcceptAction,
            Desktop,
            Mobile
        },
        props: {
            settings: {
                type: Object,
                required: true
            },
            storeDispatchList: {
                type: String | Function,
                required: true
            },
            storeDispachParams: {
                required: false,
            },
            page: {
                type: Number,
                'default': 1
            },
            hidePaginator: {
                type: Boolean,
                default: false,
            },
            selectedItems: {
                type: Array,
                required: false,
                default: () => {
                    return []
                }
            }
        },
        watch: {
            sortable: {
                handler: function (newValue) {
                    this.changePage(1);
                    this.fetchData(true);
                },
                deep: true
            },
            '$props.page'() {
                this.fetchData();
            }
        },
        mounted() {
            this.initSortColumns();
            this.fetchData();
            this.$nextTick(() => {
                window.addEventListener('resize', this.setPageWidth);
                this.setPageWidth();
            })
        },
        computed: {
            mobile() {
                const breakPoint = this.settings.mobileBreakPoint === undefined ? 768 : this.settings.mobileBreakPoint;
                return this.pageWidth < breakPoint;
            },
            columns() {
                return this.settings.columns === undefined ? [] : this.settings.columns;
            },
            queryParams() {
                return {
                    page: this.page,
                    conditions: getConditionsObject({...this.conditions}, this.settings.columns),
                    sort: getSortObject(this.sortable, this.settings.columns),
                    custom: this.storeDispachParams,
                };
            }
        },
        methods: {
            initSortColumns() {
                this.sortable.key = this.settings.defaultSortColumn === undefined ? 'id' : this.settings.defaultSortColumn;
                this.sortable.direction = this.settings.defaultSortDirection === undefined ? 'DESC' : this.settings.defaultSortDirection;
            },
            setConditions(conditions) {
                this.conditions = conditions;
                if (this.page !== 1) {
                    this.changePage(1);
                }
                this.fetchData(false);
            },
            changePage(page) {
                this.$emit('changePage', page);
            },
            fetchData(loading = true) {
                this.loading = loading;
                this.updateSelected()

                const promise = typeof this.storeDispatchList === 'function'
                    ? this.storeDispatchList(this.queryParams)
                    : this.$store.dispatch(this.storeDispatchList, this.queryParams);

                promise.then(response => {
                    this.paginator = response.paginator;
                    this.items = response.items;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    // todo:
                });
            },
            setPageWidth(event) {
                this.pageWidth = document.documentElement.clientWidth;
            },
            toggleSelected(id) {
                const selectedItems = [...this.selectedItems]
                const found = selectedItems.findIndex(item => id === item);
                if (found === -1) {
                    selectedItems.push(id)
                } else {
                    selectedItems.splice(found, 1)
                }
                this.updateSelected(selectedItems)
            },
            updateSelected(list = []) {
                this.$emit('selectedItems', list)
            }
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.setPageWidth);
        },
        data() {
            return {
                loading: true,
                paginator: {},
                items: [],
                conditions: {},
                sortable: {
                    key: 'id',
                    direction: 'DESC',
                },
                pageWidth: 0,
            };
        }
    }
</script>
<style lang="scss">
    .titan-grid {
        border-radius: 5px;

        .titan-grid-footer {
            display: flex;
            flex-direction: row;
            margin-bottom: 30px;

            .paginator {
                margin-bottom: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/DataGrid/DataGrid.vue